import { FC } from 'react';

import { type ExternalImgPath, type ImgPath, Image } from '@/shared/ui';

interface AdaptiveImageProps {
  desktopSrc: ExternalImgPath | ImgPath;
  mobileSrc: ExternalImgPath | ImgPath;
  alt: string;
  className?: string;
}

export const AdaptiveImage: FC<AdaptiveImageProps> = ({ desktopSrc, mobileSrc, alt, className }) => {
  return (
    <picture className={className}>
      <source media="(max-width: 768px)" srcSet={mobileSrc} />
      <Image src={desktopSrc} alt={alt} />
    </picture>
  );
};
